export default __webpack_public_path__ + "static/media/4.6b608dd7.jpg";